window.shakeTile = function (tile) {
    $(tile).addClass('shake');
    setTimeout(function () {
        $(tile).removeClass('shake');
    }, 800);
};
